var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loader-v2",style:(`font-family: sans-serif;`)},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-container"},[_c('div',{staticClass:"loading-text"},[_c('span',[_vm._v("L")]),_c('span',[_vm._v("O")]),_c('span',[_vm._v("A")]),_c('span',[_vm._v("D")]),_c('span',[_vm._v("I")]),_c('span',[_vm._v("N")]),_c('span',[_vm._v("G")])])])
}]

export { render, staticRenderFns }